export const formatNumberShorthand = value => {
  // Handle non-numeric values
  if (value === null || value === undefined || isNaN(value)) {
    return "0";
  }

  // Convert to number if it's not already
  const num = typeof value === "string" ? parseFloat(value) : value;

  // Define thresholds and corresponding suffixes
  const thresholds = [
    { value: 1e12, suffix: "T" }, // Trillion
    { value: 1e9, suffix: "B" }, // Billion
    { value: 1e6, suffix: "M" }, // Million
    { value: 1e3, suffix: "K" }, // Thousand
  ];

  // Find the appropriate threshold
  for (const { value: threshold, suffix } of thresholds) {
    if (Math.abs(num) >= threshold) {
      // Convert number to the format with 1 decimal place
      const formatted = (num / threshold).toFixed(1);
      // Remove decimal if it's .0
      return formatted.endsWith(".0") ? formatted.slice(0, -2) + suffix : formatted + suffix;
    }
  }

  // For numbers less than 1000, return the number as is
  // Use appropriate decimal places
  return Number.isInteger(num) ? num.toString() : num.toFixed(2);
};
